export const createPostMessageFactory = (generateUniqueNumber) => {
    return (ongoingRequests, port) => {
        return (message, transferables = []) => {
            return new Promise((resolve, reject) => {
                const id = generateUniqueNumber(ongoingRequests);
                ongoingRequests.set(id, { reject, resolve });
                port.postMessage({ id, ...message }, transferables);
            });
        };
    };
};
//# sourceMappingURL=post-message-factory.js.map